module.exports = {"321271001":"凤凰街道","321271002":"寺巷街道","321271003":"明珠街道","321271004":"沿江街道","321271100":"野徐镇","321271401":"医药城","321271402":"经济开发区","321271403":"数据园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321271.json
// module id = 931
// module chunks = 0